// extracted by mini-css-extract-plugin
module.exports = {"default":"style_default__1y83h","small":"style_small__1Kd1V"};